import React from 'react';

export default function Logo({ size = 28, showText = true, className = '', onClick, style }) {
  return (
    <span className={`backora-logo ${className}`} onClick={onClick} style={{ display: 'inline-flex', alignItems: 'center', gap: 8, cursor: onClick ? 'pointer' : 'default', ...style }}>
      <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Background circle */}
        <rect width="40" height="40" rx="10" fill="url(#backora-grad)" />
        {/* Code bracket < */}
        <path d="M16 12L8 20L16 28" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        {/* Arrow > forward */}
        <path d="M24 12L32 20L24 28" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" opacity="0.6" />
        {/* Center dot - database */}
        <circle cx="20" cy="20" r="3" fill="#fff" />
        <defs>
          <linearGradient id="backora-grad" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
            <stop stopColor="#4a90d9" />
            <stop offset="1" stopColor="#7c3aed" />
          </linearGradient>
        </defs>
      </svg>
      {showText && (
        <span style={{
          fontSize: size * 0.64,
          fontWeight: 800,
          letterSpacing: '-0.5px',
          background: 'linear-gradient(135deg, #4a90d9, #7c3aed)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
        }}>
          Backora
        </span>
      )}
    </span>
  );
}
